import React from 'react';

import { ClassName, TableViewType } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';

import { IndexTableCell } from '../IndexTableCell';

import { Icon } from '../../../../../helpers/Icon';

interface IndexTableCellIconProps {
  className?: ClassName;
  icon: IconsEnum;
  viewType?: TableViewType;
  tdClassName?: ClassName;
}

function IndexTableCellIcon({
  className,
  icon,
  viewType,
  tdClassName
}: IndexTableCellIconProps) {
  return (
    <IndexTableCell viewType={viewType} tdClassName={tdClassName}>
      <Icon className={className} icon={icon} />
    </IndexTableCell>
  );
}

export default IndexTableCellIcon;
